export const BRAILLER_REPLACEMENT_STATUS = {
    NotNeeded: { id: 1, label: "Not Needed" },
    WhateverAvailable: { id: 2, label: "Whatever is Available" },
    Classic: { id: 3, label: "Classic" },
    LightTouch: { id: 4, label: "Light Touch" }
};

export const BRAILLER_REPLACEMENT_STATUS_LIST = [
    { value: 1, text: "Not Needed" },
    { value: 2, text: "Whatever is Available" },
    { value: 3, text: "Classic" },
    { value: 4, text: "Light Touch" }
];

export const BRAILLER_STATUS = {
    Available: { id: 0, label: "Available" },
    InUse: { id: 1, label: "In Use" },
    InRepair: { id: 2, label: "In Repair" },
    OutOfService: { id: 3, label: "Out of Service" },
    Reserved: { id: 4, label: "Reserved" },
    CheckedOut: { id: 5, label: "Checked Out" },
    Damaged: { id: 6, label: "Damaged" },
    Lost: { id: 7, label: "Lost" },
    Retired: { id: 8, label: "Retired" }
};

export const BRAILLER_STATUS_LIST: { value: number; text: string }[] = [
    { value: 0, text: "Available" },
    { value: 1, text: "In Use" },
    { value: 2, text: "In Repair" },
    { value: 3, text: "Out of Service" },
    { value: 4, text: "Reserved" },
    { value: 5, text: "Checked Out" },
    { value: 6, text: "Damaged" },
    { value: 7, text: "Lost" },
    { value: 8, text: "Retired" }
];

export const REPAIR_STATUS = {
    Reported: { id: 0, label: "Reported" },
    Approved: { id: 1, label: "Approved" },
    Replaced: { id: 2, label: "Replaced" },
    Repaired: { id: 3, label: "Repaired" },
    Denied: { id: 4, label: "Denied" }
};

export const REPAIR_STATUS_LIST = [
    { value: 0, text: "Reported" },
    { value: 1, text: "Approved" },
    { value: 2, text: "Replaced" },
    { value: 3, text: "Repaired" },
    { value: 4, text: "Denied" }
];

export const BRAILLER_QUEUE_STATUS = {
    Pending: { id: 1, label: "Pending" },
    Waitlist: { id: 2, label: "Waitlist" },
    ReadyForProcessing: { id: 3, label: "Ready for Processing" },
    WaitlistProcessing: { id: 4, label: "Waitlist Processing" },
    CheckedOut: { id: 5, label: "Checked Out" },
    Cancelled: { id: 6, label: "Cancelled" }
};

export const BRAILLER_LOAN_STATUS = {
    ReadyForCheckout: { id: 1, label: "Ready for Checkout" },
    WaitList: { id: 2, label: "Wait List" },
    CheckedOut: { id: 3, label: "Checked Out" },
    Returned: { id: 5, label: "Returned" },
    Shipped: { id: 6, label: "Shipped" },
    RepairRequested: { id: 9, label: "Repair Requested" },
    RepairShipped: { id: 10, label: "Repair Shipped" },
    Cancelled: { id: 11, label: "Cancelled" }
};

export const BRAILLER_LOAN_STATUS_LIST = [
    { value: 1, text: "Ready for Checkout" },
    { value: 2, text: "Wait List" },
    { value: 3, text: "Checked Out" },
    { value: 5, text: "Returned" },
    { value: 6, text: "Shipped" },
    { value: 9, text: "Repair Requested" },
    { value: 10, text: "Repair Shipped" },
    { value: 11, text: "Cancelled" }
];
